import React from "react";
import { Card, Form, Button, Divider, message } from 'antd';
import PropTypes from 'prop-types';
import NHFetch from "../../../../utils/NHFetch";
import NHInputRender from "../../../components/common/NHInputPicker/render";
import {getLoginUser} from "@utils/NHCore";
import {getHashParam} from "../../../../utils/globalUtil";
class Common extends React.Component {
    constructor() {
        super()
        this.state = {
            hjblztData: {}, //环节办理状态信息
            hjywxData: [], //环节业务项信息
            editable: true, //是否可编辑
        }
    }

    componentWillReceiveProps(nextProps) {
        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            if (hjblztData) {
                let editable = hjblztData.blzt == '1' ? false : true;
                this.setState({ hjblztData: hjblztData, editable: editable });
            } else {
                this.setState({ hjblztData: hjblztData, editable: true });
            }
        }
    }

    //确认办理
    handleSubmit = () => {
        let zzbdhjid = getHashParam('pkid');
        const { pkid } = this.state.hjblztData;
        const form = this.props.form;
        //校验
        form.validateFields((err, formData) => {

            if (err) {
                return;
            }

            let userId = getLoginUser() ? getLoginUser().userId : '';
            let params = { xsid: userId, lchjid: pkid, formData: formData, yhid: userId ,zzbdhjid:zzbdhjid};

            NHFetch('/zdybl/saveCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理成功！');
                            //办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish();
                            }
                        } else {
                            message.error('环节办理失败，请重试！');
                        }
                    }
                })
        });
    }

    //取消办理
    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        let zzbdhjid = getHashParam('pkid');
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid ,zzbdhjid:zzbdhjid};
        NHFetch('/zdybl/cancelCustomLinkData', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data == '1') {
                        message.success('环节办理取消成功！');
                        //取消办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish();
                        }
                    } else {
                        message.error('环节办理取消失败，请重试！');
                    }
                }
            })
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }

    render() {
        const { form, hjywxData, hjblztData, hasLast, hasNext } = this.props;
        const { editable } = this.state;

        let formItems = [];
        let formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 8 },
            }
        }

        if (hjywxData && hjywxData.length > 0) {
            for (let key in hjywxData) {
                let hjywx = hjywxData[key];
                let formItem = (
                    <NHInputRender key={key} id={hjywx.pkid} label={hjywx.zdmc} defaultValue={hjywx.mrz} value={hjywx.ywxz}
                        required={hjywx.sfbt == '1' ? true : false} form={form} feature={hjywx.kjcs}
                        readOnly={editable ? false : true} formItemLayout={formItemLayout} />
                );
                formItems.push(formItem);
            }

        } else {
            let formItem = (<span>暂无需要填写的业务项信息</span>);
            formItems.push(formItem);
        }
        return (
            <div>
                <Card type="inner" title={hjblztData && hjblztData.hjmc ? `${hjblztData.hjmc}业务信息` : '业务信息'}>
                    <Form>
                        {formItems}
                    </Form>
                </Card>
                <div style={{position:'relative',textAlign:'center'}}>
                {
                    editable ?
                        <Button  type="primary" style={{position: 'absolute',top: '74px',left: '308px'}}
                           onClick={this.handleSubmit}>确认办理</Button>
                        :<Button type="primary" style={{position: 'absolute',top: '74px',left: '308px'}}
                                 onClick={this.handleCancel}>取消办理</Button>
                }
                </div>
            </div>
        )
    }
}

const common = Form.create()(Common);

Common.propTypes = {
    xsData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态数据
    hjywxData: PropTypes.array, //环节业务项数据
}
export default common


// WEBPACK FOOTER //
// ./app/pages/SelfHelp/customLink/common.js